import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAccessTokenValid } from '../utils/validateToken';
import { useIsMobile } from '../hooks/useIsMobile';
import ProfileMenu from './ProfileMenu';
import ButtonComponent from './Button';
import HamburgerMenu from './HamburgerMenu';
import logo from '/images/junfel-logo.svg'
import MobileMenu from './MobileMenu';
import '../styles/navbar.css';
import { Key } from 'lucide-react';
import { ROUTES } from '../router/appRoutes';

const Navbar = () => {
	const [ isOpen, setIsOpen ] = useState(false)
	const [ barClass, setBarClass] = useState('hamburger_close')
	const { isLoggedIn, accessToken } = useSelector((state) => state.auth);
	const isTokenValid = isAccessTokenValid(accessToken);
	const isMobile = useIsMobile();
	const menuRef = useRef(null);
	
	const handleMenu = () => {
		setIsOpen(open => !open)
		if (isOpen) {
			setBarClass('hamburger_close')
		} else {
			setBarClass('hamburger_open')
		}
	}
	
	useEffect(() => {
		// Add event listener when component mounts
		document.addEventListener("mousedown", (e) => {
			if (menuRef.current && !menuRef.current.contains(e.target)) {
				setIsOpen(false);
				setBarClass("hamburger_close");
			}
		});

		// Clean up the event listener when component unmounts
		return () => {
			document.removeEventListener("mousedown", (e) => {
				if (menuRef.current && !menuRef.current.contains(e.target)) {
					setIsOpen(false);
					setBarClass("hamburger_close");
				}
			});
		};
	}, []);

	return (
		<nav>
			<div>
				<a href="/"><img src={logo}	alt="Junfel logo"	className="logo" width={72} height={24}/></a>
				<span className='version'>&nbsp; v5</span>
			</div>
			<div className='right-menu'>
				{isMobile ? (
					// MOBILE DISPLAY
					<div ref={menuRef}>
						<HamburgerMenu onClick={handleMenu} name='menu' className={barClass}/>
						{isOpen && <MobileMenu setIsOpen={setIsOpen} className={setBarClass} />}
					</div>
				) : (
					// DESKTOP DISPLAY
					<ul className="nav_menu">
						<li><NavLink to={ROUTES.HOME} className='nav_link'> Home </NavLink></li>
						<li><NavLink to={ROUTES.PROJECTS} className='nav_link'> Projects </NavLink></li>
						{/* <li><NavLink to="/blogs" className='nav_link'> Blogs </NavLink></li> */}
						<li><NavLink to={ROUTES.CONTACT} className='nav_link'> Contact	</NavLink></li>
						
						{ isTokenValid && isLoggedIn ? (
							// AUTHENTICATED USER
							<>
								<li><NavLink to={ROUTES.DASHBOARD} className='nav_link'> Dashboard </NavLink></li>
								{/* <li><ProfileMenu /></li> */}
							</>
						) : (
							// NON-AUTHENTICATED USER
							<li>
								<NavLink to={ROUTES.LOGIN} className="login">
									<Key size="16"/> &nbsp; Login
								</NavLink>
							</li>
						)}
					</ul>
				)}
			</div>
		</nav>
	);
};

export default Navbar;
